import React, { useEffect, useRef, useState } from "react";
import { LoadingPanel } from "../../components/layout/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import {
  createParty,
  findAllActiveParty,
  getPartyById,
  updateParty,
} from "./services/party.services";
import { clearPartyDetail } from "./partySlice";
// import { clearItemDetail } from "../item/itemSlice";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormTextField from "../../components/formFields/FormTextField";
import {
  emailWOValueValidator,
  gstWOValueValidator,
  mobileNoValidator,
  panWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import {
  CREDIT_DEBIT,
  STATUSARRAY,
  WITHWITHOUTARRAY,
} from "../../_contstants/common";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { Button } from "@progress/kendo-react-buttons";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import ContactDetailsArray from "./ContactDetailsArray";
import PartyImageArray from "./PartyImageArray";
import ChargesDetailArray from "./ChargesDetailArray";
import FormTextArea from "../../components/formFields/FormTextArea";
import { CustomAppDrawer } from "../../components/muidrawer/Drawer";
import CreateCharges from "../charges/CreateCharges";
import { closeChargesDrawerOpen } from "../charges/chargesSlice";
import { closeUnitDrawerOpen } from "../unit/unitSlice";
import CreateUnit from "../unit/CreateUnit";

const CreateParty: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const PartyDetail = useAppSelector(
    (state: RootState) => state.party.PartyDetail
  );
  const loading = useAppSelector((state) => state.party.loading);
  const formLoading = useAppSelector((state) => state.party.formLoading);
  const chargesDrawerOpen = useAppSelector(
    (state) => state.charges.chargesDrawerOpen
  );
  const unitDrawerOpen = useAppSelector((state) => state.unit.unitDrawerOpen);
  const [formKey, setFormKey] = useState(1);

  const party_guid = location.state?.party_guid;
  const gridRef = useRef<any>(null);

  const PROVIDE_BANK_DETAILS = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  useEffect(() => {
    if (party_guid) {
      dispatch(getPartyById(party_guid));
    }
  }, [party_guid]);

  useEffect(() => {
    dispatch(findAllActiveParty());
    return () => {
      dispatch(clearPartyDetail());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      if (!party_guid) {
        const insertpayload = {
          party_name: values.party_name,
          party_nick_name: values.party_nick_name,
          mobile_no: values.mobile_no,
          address: values.address,
          email: values.email,
          pan_no: values.pan_no,
          gst_no: values.gst_no,
          opening_balance: values.opening_balance ? +values.opening_balance : 0,
          credit_debit: values.credit_debit,
          rs_opening_balance: values.rs_opening_balance
            ? +values.rs_opening_balance
            : 0,
          rs_credit_debit: values.rs_credit_debit,
          provide_bank_details: values.provide_bank_details,
          bank_account_name: values.bank_account_name,
          ifsc_code: values.ifsc_code,
          bank_name: values.bank_name,
          branch: values.branch,
          account_no: values.account_no,
          remarks: values.remarks,
          with_without_variation: values?.with_without_variation === 1,
          contact_details: values.contact_details
            ? values.contact_details.map((contact_detail: any) => {
                return {
                  party_id: contact_detail.party_id,
                  person_name: contact_detail.person_name,
                  country_code: contact_detail.country_code,
                  mobile_no: contact_detail.mobile_no,
                  email: contact_detail.email,
                  department: contact_detail.department,
                };
              })
            : [],
          charges_details: values.charges_details
            ? values.charges_details.map((chargesDetail: any) => {
                return {
                  // party_id: chargesDetail.party_id ? +chargesDetail.party_id : null,
                  charge_id: chargesDetail.charge_id
                    ? +chargesDetail.charge_id
                    : null,
                  unit_id: chargesDetail.unit_id
                    ? +chargesDetail.unit_id
                    : null,
                  charges_type: chargesDetail.charges_type
                    ? +chargesDetail.charges_type
                    : null,
                  charges: chargesDetail.charges,
                };
              })
            : [],
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createParty(insertpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/party/edit", {
            state: {
              party_guid: response?.payload?.party_guid,
            },
          });
        }
      } else {
        const editpayload = {
          party_guid: party_guid,
          id: values.id,
          party_name: values.party_name,
          party_nick_name: values.party_nick_name,
          mobile_no: values.mobile_no,
          address: values.address,
          email: values.email,
          pan_no: values.pan_no,
          gst_no: values.gst_no,
          opening_balance: values.opening_balance ? +values.opening_balance : 0,
          credit_debit: values.credit_debit,
          rs_opening_balance: values.rs_opening_balance
            ? +values.rs_opening_balance
            : 0,
          rs_credit_debit: values.rs_credit_debit,
          provide_bank_details: values.provide_bank_details,
          bank_account_name: values.bank_account_name,
          ifsc_code: values.ifsc_code,
          bank_name: values.bank_name,
          branch: values.branch,
          account_no: values.account_no,
          remarks: values.remarks,
          with_without_variation: values?.with_without_variation === 1,
          contact_details: values.contact_details
            ? values.contact_details.map((contact_detail: any) => {
                return {
                  party_id: contact_detail.party_id,
                  person_name: contact_detail.person_name,
                  country_code: contact_detail.country_code,
                  mobile_no: contact_detail.mobile_no,
                  email: contact_detail.email,
                  department: contact_detail.department,
                };
              })
            : [],
          charges_details: values.charges_details
            ? values.charges_details.map((chargesDetail: any) => {
                return {
                  party_id: chargesDetail.party_id,
                  item_id: chargesDetail.item_id,
                  unit_id: chargesDetail.unit_id,
                  charges_type: chargesDetail.charges_type,
                  charges: chargesDetail.charges,
                };
              })
            : [],
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateParty(editpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getPartyById(party_guid));
        }
        navigate("/party");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };
  const handleFormClose = () => {
    navigate("/party");
  };
  const handleBack = () => {
    navigate("/party");
  };
  useEffect(() => {
    setFormKey(formKey + 1);
  }, [PartyDetail]);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {chargesDrawerOpen && (
        <CustomAppDrawer
          open={chargesDrawerOpen}
          closeDrawerFunction={closeChargesDrawerOpen}
        >
          <CreateCharges />
        </CustomAppDrawer>
      )}
      {unitDrawerOpen && (
        <CustomAppDrawer
          open={unitDrawerOpen}
          closeDrawerFunction={closeUnitDrawerOpen}
        >
          <CreateUnit />
        </CustomAppDrawer>
      )}
      <Form
        onSubmit={handleSubmit}
        initialValues={PartyDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {party_guid ? "Update Vepari" : "Create Vepari"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {party_guid ? (
                    <Typography.h5>
                      Vepari No :{" "}
                      <span style={{ color: "green" }}>{PartyDetail.id}</span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="party_name"
                    label="Vepari Name"
                    placeholder="i.e. Jhone Doe"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="party_nick_name"
                    label="Vepari Nick Name"
                    placeholder="i.e. JD"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="mobile_no"
                    label="Phone No"
                    type={"number"}
                    placeholder="i.e. 9876543210"
                    max={10}
                    component={FormTextField}
                    validator={mobileNoValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="address"
                    label="Address"
                    placeholder="Address"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="email"
                    label="Email"
                    placeholder="i.e. example@gmail.com"
                    component={FormTextField}
                    validator={emailWOValueValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="pan_no"
                    label="PAN No"
                    placeholder="i.e. ABCDE1234F"
                    component={FormTextField}
                    validator={panWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="gst_no"
                    label="GST No"
                    placeholder="i.e. 11AAAAA1111A1Z1"
                    component={FormTextField}
                    validator={gstWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperClassName="w-100"
                    name="opening_balance"
                    label="Phine (gm) Opening Balance"
                    type={"number"}
                    placeholder="000.00"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                  <Field
                    wrapperClassName="w-90"
                    name="credit_debit"
                    label="Cr/Dr"
                    defaultValue="Credit"
                    component={FormSelectionField}
                    options={CREDIT_DEBIT?.map((cr_dr: any) => {
                      return {
                        value: cr_dr.value,
                        label: cr_dr.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperClassName="w-100"
                    name="rs_opening_balance"
                    label="Rs.Opening Balance"
                    placeholder="000.00"
                    type={"number"}
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                  <Field
                    wrapperClassName="w-90"
                    name="rs_credit_debit"
                    label="Cr/Dr"
                    defaultValue="Credit"
                    component={FormSelectionField}
                    options={CREDIT_DEBIT?.map((cr_dr: any) => {
                      return {
                        value: cr_dr.value,
                        label: cr_dr.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    label="Provide Bank Details"
                    component={FormRadioGroup}
                    name={`provide_bank_details`}
                    layout="horizontal"
                    options={PROVIDE_BANK_DETAILS}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={"with_without_variation"}
                    component={FormSelectionField}
                    label="Variation"
                    placeholder="Select Variation"
                    validator={requiredValidator}
                    astrike={true}
                    options={WITHWITHOUTARRAY?.map((status: any) => {
                      return {
                        value: status.value,
                        label: status.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem></GridLayoutItem>
                {formRenderProps.valueGetter("provide_bank_details") ===
                  true && (
                  <>
                    <GridLayoutItem>
                      <Field
                        name="bank_account_name"
                        label="Bank Account Name"
                        placeholder="i.e. Jhone Doe"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="bank_name"
                        label="Bank Name"
                        placeholder="i.e. Bank Of Baroda"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="account_no"
                        label="Account No"
                        placeholder="i.e. 5059011115478"
                        type={"number"}
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="branch"
                        label="Branch"
                        placeholder="i.e. Vatva"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="ifsc_code"
                        label="IFSC Code"
                        placeholder="i.e. BARB0DBVATV"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                  </>
                )}

                <GridLayoutItem>
                  <Field
                    id={"IsActive"}
                    name={"isactive"}
                    component={FormSelectionField}
                    label={"Status"}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status.value,
                        label: status.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="remarks"
                    label="Remarks"
                    placeholder="Write here..."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem colSpan={6}>
                <Typography.h4>Contact Details List</Typography.h4>
              </GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={ContactDetailsArray}
                name="contact_details"
              />
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem colSpan={5}>
                <Typography.h4>Charges Details List</Typography.h4>
              </GridLayoutItem>

              <FieldArray
                formRenderProps={formRenderProps}
                component={ChargesDetailArray}
                name="charges_details"
              />
              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <Button
                  type="button"
                  themeColor={"primary"}
                  style={{ marginRight: 4 }}
                  onClick={handleBack}
                >
                  Go to Vepari List
                </Button>
                <ButtonWithLoading
                  label={!party_guid ? "Create" : "Update"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 4 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </ShadowCard>
            {formLoading ? (
              <LoadingPanel gridRef={gridRef} />
            ) : (
              party_guid && (
                <ShadowCard style={{ marginTop: 10 }}>
                  <GridLayoutItem colSpan={5}>
                    <Typography.h4>Documents Upload</Typography.h4>
                  </GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={PartyImageArray}
                    name="party_images"
                  />
                </ShadowCard>
              )
            )}
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateParty;
